import { Component, Input } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { NgClass, NgIf, NgTemplateOutlet } from "@angular/common";
import { CartItem } from "../../../../_core/state/cart/cart.model";
import { CartService } from "../../../../_core/state/cart/cart.service";

@Component({
	selector: 'app-item-review-status-sum',
	standalone: true,
	imports: [MatIconModule, MatProgressSpinnerModule, NgIf, NgClass, NgTemplateOutlet],
	templateUrl: './item-review-status-sum.component.html',
	styleUrl: './item-review-status-sum.component.scss'
})
export class ItemReviewStatusSumComponent {
	@Input() items: CartItem[] = [];
	@Input() actionInProgress: { group?: any; itemIds?: string[] } | null;

	constructor(
		public readonly projectCartService: CartService
	) {}
}
